export default {
  "icon": "_icon_5bj6j_1",
  "grow-wrap": "_grow-wrap_5bj6j_11",
  "textarea": "_textarea_5bj6j_27"
};import "ni:sha-256;5v7GSwVBySw7_mXEFJ_EnHx_SEaPGJyfPIl0qG28DMM";